<div class="d-flex">
    <div [ngClass]="{'entity-tail px-p-10 px-mb-10': entityTailConfig.legalEntity }">
        <div class="d-flex flex-column">
            <div>
                <span class="font-weight-bold"
                  *ngIf="entityTailConfig.legalEntity">{{entityTailConfig.legalEntity.name}}</span>
                <div class="table-input">
                    <div class="d-flex flex-row header">
                        <div class="px-w-60">Time</div>
                        <div class="px-w-40"></div>
                        <div class="px-w-95"></div>
                        <div class="px-w-75">Tail</div>
                        <div class="px-w-35"></div>
                        <div class="px-w-35"></div>
                    </div>
                    <app-time-range-tail
                        *ngFor="let timeRangeTail of entityTailConfig.yearRangeTails; let index = index;"
                        [timeRangeTail]="timeRangeTail"
                        [from]="timeRangeTail.from"
                        [tailIndex]="index"
                        [isLast]="false"
                        (removeTimeRangeTail)="onRemoveModelTimeRangeTail(index)"
                        (toChange)="onItemToChange($event, index)">
                    </app-time-range-tail>
                </div>
            </div>

            <div class="d-flex px-mt-10 " >
                <div class="">
                    <button class="btn btn-sm btn-basic" (click)="addTimePeriod()">
                        ADD TIME PERIOD
                    </button>
                </div>
                <div *ngIf="entityList">
                    <div class=" flex-row align-items-center ">
                        <span>Copy to: </span>
                        <select class="px-ml-10 copySelect" [(ngModel)]="copyTo">
                            <option></option>
                            <option *ngFor="let item of entityListWithoutCurrentEntity; let index = index;" [ngValue]="item.dataName">
                                {{item.name}}
                            </option>
                        </select>
                        <button class="btn btn-sm btn-basic copybtn px-ml-10" (click)="onCopyToAnotherEntity(copyTo)">
                            COPY
                        </button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
